export enum STATUS_INFO {
  Refused = 'jbp-commitment-status-refused',
  Acknowledged = 'jbp-commitment-status-acknowledged',
  CheckIcon = 'kbase kbase-check-circle-alt',
  CheckIconColor = '#1D8348',
  CloseIcon = 'kbase kbase-close-circle-alt',
  CloseIconColor = '#FC1A1A',
  ClockIcon = 'kbase kbase-lvl-clock',
  ClockIconColor = '#FB8500',
}
